export default {
    data: () => ({
        translations: {
            title: {
                el: "Κουπόνια με Προϊόντα",
                en: "Product Coupons",
                it: "Coupon per Prodotti"
            },
            info: {
                el: "Δημιουργήστε κουπόνι '1+1 δώρο' ή ένα κουπόνι δείγματος στα προϊόντα σας.",
                en:
                    "Create a 'Buy one, Get one free' or a sampling promo coupon on your products.",
                it: "Crea un 'prendi due, paghi uno' o un buono campione per i tuoi prodotti."
            },
            addAction: {
                el: "Προσθήκη Προωθητικής Ενέργειας",
                en: "Add Promo Action",
                it: "Aggiungi Energia Promozionale"
            },
            type: {
                el: "Τύπος",
                en: "Type",
                it: "Tipo"
            },
            productForSale: {
                el: "Προϊόν για αγορά",
                en: "Purchase Product",
                it: "Prodotto per l'acquisto"
            },
            productForGift: {
                el: "Προϊόν για δώρο",
                en: "Giveaway Product",
                it: "Prodotto per regalo"
            },
            quantity: {
                el: "Ποσότητα",
                en: "Quantity",
                it: "Quantità"
            },
            actions: {
                el: "Ενέργειες",
                en: "Actions",
                it: "Azioni"
            },
            social: {
                el: "Μοιράσου το στα Social Media",
                en: "Social Media",
                it: "Condividilo sui social media"
            },
            noData: {
                el: "Δεν υπάρχουν δεδομένα",
                en: "No data available",
                it: "Nessun dato disponibile"
            },
            update: {
                el: "Επεξεργασία",
                en: "Update",
                it: "Aggiornamento"
            },
            delete: {
                el: "Διαγραφή",
                en: "Delete",
                it: "Cancellare"
            },
            share: {
                el: "",
                en: "Share",
                it: ""
            },
            deleteAction: {
                el: "",
                en: "Delete Action",
                it: ""
            },
            areYouSure: {
                el: "",
                en: "Are you sure you want to delete",
                it: ""
            },
            paginationText: {
                el: "από",
                en: "of",
                it: "di"
            }
        }
    })
};
